import React from "react";
import { isEqual } from "lodash";
import classNames from "classnames";

import { useUpdatedRef } from "utils/hooks";
import { createKeyboardShortcut } from "utils/keyboardShortcuts";

import Tooltip from "components/Tooltip";

import style from "./style.module.scss";

const typeClasses = (type) =>
    ({
        small: style.small,
        enclosureView: style.enclosureView,
        default: style.default,
    }[type || "default"]);

const ToggleMulti = React.memo(({
    options = [],
    active = "",
    className,
    disabled: toggleDisabled,
    type = "default",
}) => {
    const [activeRef, updateActiveRef] = useUpdatedRef();
    const { offsetWidth: activeWidth = 32, offsetLeft: activeLeft = 4 } = activeRef || {};

    const classes = classNames(style.toggleMulti, {
        [className]: className,
        [style.disabled]: toggleDisabled,
        [typeClasses(type)]: type,
    });

    return (
        <div className={classes}
            {...createKeyboardShortcut({
                onKeyDown: () => {
                    var nextOption = options.find(({ id }) => id === active) ? options.find(({ id }) => id === active) : options[0];
                    nextOption = options[options.indexOf(nextOption) + 1] || options[0];
                    if (nextOption) {
                        nextOption.onClick();
                    }
                }
            })}
        >
            <div className={style.switch} style={{ left: activeLeft, width: activeWidth }}></div>
            {options.map(({ id, label, icon: Icon, tip, onClick, disabled, className, activeClass }) => {
                const isActive = active === id;
                const optionClasses = classNames(style.toggleOption, {
                    [style.active]: isActive,
                    [style.disabled]: disabled || toggleDisabled,
                    [className]: className,
                    [activeClass]: activeClass && isActive,
                });
                return (
                    <div
                        key={id}
                        ref={isActive ? updateActiveRef : null}
                        className={optionClasses}
                        onClick={disabled ? () => {} : onClick}
                        data-for={`toggleTip-${id}`}
                        data-tip={tip}
                    >
                        {Icon && (
                            <div className={style.icon}>
                                <Icon />
                            </div>
                        )}
                        {typeof label === "string" ? label && <span className={style.labelText}>{label}</span> : label}
                        {tip && <Tooltip id={`toggleTip-${id}`} proximity={8} delay />}
                    </div>
                );
            })}
        </div>
    );
}, isEqual);

export default ToggleMulti;
